import script from "./AccountApply.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountApply.vue?vue&type=script&setup=true&lang=ts"

import "./AccountApply.vue?vue&type=style&index=0&id=101c41c3&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101c41c3"]])

export default __exports__